import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Col, Typography, Row} from 'antd';
import '../../App.css';
import balloonIMG from '../../assets/BannerGlobos.png'
import towersIMG from '../../assets/BannerTorres.png'

const { Text } = Typography;

interface MobileFeedbackBannerProps {
  gameCode?: 'BAR2' | 'TOW2';
}

function MobileFeedbackBanner({ gameCode = 'BAR2' }: MobileFeedbackBannerProps) {
  const isTowers = gameCode === 'TOW2';
  const subtitle = isTowers ? 'RESULTADOS JUEGO TORRES' : 'RESULTADOS JUEGO GLOBOS';
  const image = isTowers ? towersIMG : balloonIMG;
  
  return (
    <Row className='title-layout'  justify='center' gutter={24} style={{width: '100%', display: 'flex' ,flexDirection: 'column', justifyContent: 'center'}} >
        <Col sm={12}>
         <Row style={{ display: 'flex' ,flexDirection: 'column', marginTop: '1em', height:'100%', justifyContent: 'center'}} >
          <Row style={{ display: 'flex' ,flexDirection: 'row',  height:'100%', justifyContent: 'center'}} >
            <Text strong style={{
                fontSize: '2.5vh',
                color: '#f5edf0'
                }}>
                Reporte Genomawork
            </Text>
            </Row>
            <Row style={{ display: 'flex' ,flexDirection: 'row', marginTop: '0.5em', height:'100%', justifyContent: 'center'}} >
            <Text style={{
            color: '#f5edf0',
            fontSize: '1.25vh',
            }}>
            {subtitle}
            </Text>
            </Row>
        </Row>
        </Col>
        <Col sm={12}>
         <Row style={{ display: 'flex' ,flexDirection: 'row', marginTop: '1em', height:'100%', justifyContent: 'center'}} >
            <img src={ image } alt='' style={{ minHeight:'20vh', maxHeight:'35vh' }} />
         </Row>
        </Col>
        
    </Row>
  )}

  export default MobileFeedbackBanner;